/**
 * Statically bundled English resources for the namespaces reachable from the
 * public routes. i18next downloads the fallback language ("en") for every
 * visitor anyway, so bundling these into the entry chunk costs no extra bytes
 * while removing eight serial-ish locale requests (and the translation
 * Suspense wait) from the public routes' LCP path (TRA-115).
 *
 * Authenticated-only namespaces (admin, lesson, dashboard, ...) and the other
 * languages stay lazy via the i18n backend in ./lazyResources.
 */
import common from './locales/en/common.json'
import navigation from './locales/en/navigation.json'
import seo from './locales/en/seo.json'
import auth from './locales/en/auth.json'
import errors from './locales/en/errors.json'
import landing from './locales/en/landing.json'
import privacy from './locales/en/privacy.json'
import profile from './locales/en/profile.json'
import notFound from './locales/en/notFound.json'

/** Namespaces preloaded for public routes; the en copies are bundled below. */
export const PUBLIC_NAMESPACES = [
    'common',
    'navigation',
    'seo',
    'auth',
    'errors',
    'landing',
    'privacy',
    'profile',
    'notFound',
] as const

/**
 * Namespaces only reachable behind authentication. Warmed in the background
 * once the user authenticates (see ProtectedRoute) so components that use
 * prefixed keys (t('review:...')) without declaring the namespace still
 * resolve under lazy locale loading.
 */
export const AUTHENTICATED_NAMESPACES = [
    'admin',
    'dashboard',
    'feedback',
    'lesson',
    'reader',
    'review',
    'vocab',
] as const

export const publicEnResources = {
    en: {
        common,
        navigation,
        seo,
        auth,
        errors,
        landing,
        privacy,
        profile,
        notFound,
    },
} as const
